/**
 * Typescript's array type guard function.
 * @example <caption>Usage: </caption>
 * const array: [number | undefined] = [];
 * array.filter(notUndefined); // <- Returns clear typed number array
 */
export function notUndefined<T>(x: T | undefined): x is T {
  return x !== undefined;
}
